import { DsoAddressClient } from 'types';
import { AddressOption } from './AddressSearch.types';

export const buildAddressOptions = (
  addresses: DsoAddressClient[] | undefined,
  excludedAddresses: string[] = []
): AddressOption[] => {
  if (!addresses || addresses.length === 0) {
    return [];
  }

  return addresses
    .filter(address => !excludedAddresses.includes(address.accountNumber))
    .map(address => ({
      label: `${address.accountName} (${address.accountNumber}) - ${address.accountAddress}`,
      value: address.accountNumber,
      accountName: address.accountName,
      accountAddress: address.accountAddress,
    }));
};
